import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import Compressor from 'compressorjs';
import {useSelector} from "react-redux";
import {store} from "./../../app/store";
import {selectMediakitUser, setMediakitUser} from "./../../features/stores/mediakitUser.slice";
import ModalCrop from "../ModalCrop";
import styles from "./AvatarDisplay.module.scss";
import defaultAvatar from './../../assets/images/al_default_avatar.png';
import EditImg from './../../assets/images/profile_edit.png';
import {setDataChange} from "./../../features/stores/changeData.slice";
import {blobToBase64, convertBase64ToBlob} from "../../Helper/imageCropper";

const selectUser = (state: any) => state?.user?.me?.linksUser;

const AvatarDisplay: React.FC = ()=> {
  const {t} = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const mediakitUser = useSelector(selectMediakitUser);
  const user = useSelector(selectUser);

  const handleOpenChoseImage = () => {
    document.getElementById('avatarInput')?.click();
  };

  const readFile = (file: any) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener('load', () => resolve(reader.result), false);
      reader.readAsDataURL(file);
    });
  };

  const fileSelectedHandler = async (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      const imageDataUrl = await readFile(e.target.files[0]) as string;
      store.dispatch(setMediakitUser({...mediakitUser, avatarUrl: imageDataUrl}));
    }
    setIsOpen(true);
  };

  return (
      <>
      {isOpen && (
        <ModalCrop setIsOpen={setIsOpen} imgSrc={mediakitUser.avatarUrl} setImageUrl={(image) => {
          if (image.includes('base64')) {
            new Compressor(convertBase64ToBlob(image), {
              quality: 0.8,
              async success(result) {
                const baseImage = await blobToBase64(result) as string;
                store.dispatch(setMediakitUser({...mediakitUser, avatarUrl: baseImage}));
                store.dispatch(setDataChange(true));
              },
              error(err) {
                console.log(err.message);
              },
            });
         } else {
            store.dispatch(setMediakitUser({...mediakitUser, avatarUrl: image}));
          }
        }}
        type={'profile'}
        handleCancelUpload={() => {
          store.dispatch(setMediakitUser({...mediakitUser, avatarUrl: user?.avatar?.url || defaultAvatar}));
        }}
        />
      )}
      <div
          className={styles.avatar_wrapper}
          onClick={handleOpenChoseImage}
          style={{
              backgroundImage: `url(${mediakitUser.avatarUrl || defaultAvatar})`,
          }}
      >
          <img src={EditImg} className={styles.edit_img} />
          <input
              id="avatarInput"
              style={{display: 'none'}}
              type='file'
              onChange={(e: any) => {
                  fileSelectedHandler(e);
              }}
          />
      </div>
      </>
  );
};

export default AvatarDisplay;
